/**
 * P3-2 客户健康度告警卡（按 level 分组）
 */
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { $ } from '../../lib/api';
import { fmtDateShort } from '../../lib/format';
import { HomeCard, Pill } from '../ui';

const LEVEL_META: Record<string, { label: string; color: string; icon: string }> = {
  warning:    { label: '⚠️ 警告',     color: '#faad14',         icon: '🟡' },
  urgent:     { label: '🟠 紧急',     color: '#fa8c16',         icon: '🟠' },
  death:      { label: '🔴 已逾期',   color: 'var(--danger)',   icon: '🔴' },
  dying:      { label: '💀 濒死',     color: 'var(--danger)',   icon: '💀' },
  pool_force: { label: '⚰️ 即将进公海', color: 'var(--danger)', icon: '⚰️' },
};

export function HealthAlertsCard() {
  const { data } = useQuery<any>({
    queryKey: ['health-overview'],
    queryFn: () => $.get('/customer-protection/health-overview'),
    refetchInterval: 60_000,
  });
  if (!data) return null;
  const samples = data.samples ?? [];
  const byLevel = data.byLevel ?? {};
  const total = Object.values(byLevel).reduce((s: number, n: any) => s + Number(n), 0);
  if (total === 0) {
    return (
      <HomeCard title="📊 客户健康度">
        <div style={{ padding: 24, textAlign: 'center', color: 'var(--success)' }}>
          ✅ 太棒了，所有客户跟进周期正常
        </div>
      </HomeCard>
    );
  }
  return (
    <HomeCard title={<>📊 客户健康度 <span style={{ fontSize: 12, color: 'var(--text-3)', fontWeight: 400, marginLeft: 6 }}>{total} 个客户需关注</span></>}>
      <div style={{ padding: '8px 16px' }}>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 12 }}>
          {Object.entries(byLevel).map(([lvl, cnt]: any) => {
            const m = LEVEL_META[lvl];
            if (!m || Number(cnt) === 0) return null;
            return (
              <span key={lvl} style={{
                padding: '4px 10px', borderRadius: 4, fontSize: 12,
                background: m.color + '14', color: m.color, fontWeight: 500,
              }}>
                {m.label} {cnt}
              </span>
            );
          })}
        </div>
        {samples.slice(0, 6).map((c: any) => {
          const m = LEVEL_META[c.currentAlertLevel] ?? LEVEL_META.warning;
          return (
            <Link key={c.id} to={`/customers/${c.id}`} style={{ textDecoration: 'none' }}>
              <div style={{
                padding: '8px 10px', marginBottom: 6, borderRadius: 4,
                background: 'var(--bg-2)', borderLeft: `3px solid ${m.color}`,
                display: 'flex', alignItems: 'center', gap: 8,
              }}>
                <span>{m.icon}</span>
                <span style={{ flex: 1 }}>{c.nickname}</span>
                <Pill tone="default">{c.currentStage}</Pill>
                {c.nextFollowupDueAt && (
                  <span style={{ fontSize: 11, color: 'var(--text-3)' }}>
                    截止 {fmtDateShort(c.nextFollowupDueAt)}
                  </span>
                )}
              </div>
            </Link>
          );
        })}
        {/* 条7：原 ?alert=urgent 是死参(后端无 alert 筛选)→ 列表忽略、全显示。改指向受支持的「低健康度」筛选(健康度≤69=未达绿线)。
            注：告警按【跟进逾期等级】计数、与健康度分非同一口径，此处为近似「需关注客户」视图，列表顶部有可清除横幅说明。 */}
        {samples.length > 6 && (
          <Link to="/customers?maxHealth=69" style={{ fontSize: 12, color: 'var(--purple)' }}>
            查看健康度偏低客户 →
          </Link>
        )}
      </div>
    </HomeCard>
  );
}
